<template>
	<Expose class="login-expose" :active="active" v-on:expose-close="$root.$data.showLoginForm = null">
		<LoginForm v-if="active" class="login-expose__form" @success="$root.$data.showLoginForm = null"></LoginForm>
	</Expose>
</template>

<script>
import Expose from '../molecules/Expose'
import LoginForm from '../molecules/LoginForm'

export default {
	name: 'LoginExpose',
	components: {
		Expose,
		LoginForm
	},
	data () {
		return {
		}
	},
	props: {
		active: Boolean
	},
	computed: {
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".login-expose";
	#{$c}
	{
		@supports (backdrop-filter: blur(5px)) or (-webkit-backdrop-filter: blur(5px))
		{
			background-color: transparentize(palette(black, base, true), 1) !important;
		}

		&__form
		{
			@include extend(bgc-pal--white);
			padding: rem(32) rem(48) rem(48);
			box-shadow: 0 4px 8px rgba(0,0,0,0.05);
			width: 432px;
			max-width: 100%;
		}

		.expose__close
		{
			display: none;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/organisms/LoginExpose.vue